<app-turn-down-button [dealId]="dealId"></app-turn-down-button>